var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mg-b-10 mg-t-10 w-b-93 myInput"},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 18 ,maxRows: 20},"placeholder":_vm.placeholder},on:{"input":_vm.iptChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }